import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/styles.module.scss';

import AdminReplyItem from '../../../application/javascripts/react_components/feeds/AdminReplyItem';
import TrailUgcCardContent from '../TrailUgcCardContent';
import FirstToReviewBadge from '../../../../assets/images/icons/first-to-review.svg';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import OriginalLanguageButton from '../../shared/OriginalLanguageButton';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';
import { inIframe } from '../../../utils/trail_helpers';

class TrailReviewResultCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInTranslatedLang: false,
      showReplyEditing: false
    };
  }

  openReviewFormModal = e => {
    e.preventDefault();
    const params = { ...this.props.review, multistep: true };

    if (inIframe()) {
      const event = new CustomEvent('openTrailFormModal', { detail: { activeTrailFormModal: 'reviews', trailFormProps: params } });
      window.parent.document.dispatchEvent(event);
    } else {
      this.props.openReviewFormModal('reviews', params);
    }
  };

  recordingLink = () => {
    if (this.props.review.associatedRecording && this.props.review.user) {
      const recording = this.props.review.associatedRecording;
      const viewUsersRecording = StringConstantsMixin.strings.VIEW_USERS_RECORDING.replace('{userName}', this.props.review.user.firstName);
      return (
        <a
          className={`${styles.link} ${styles.recording} ${StringConstantsMixin.constants.XLATE.NONE}`}
          href={LanguageSupportUtil.wrapUrlSafe(`/explore/recording/${recording.slug}`)}
          target="_blank"
        >
          {viewUsersRecording}
        </a>
      );
    }
    return null;
  };

  actionsDiv = () => {
    let langButton = null;
    if (this.props.review.comment_source) {
      langButton = (
        <OriginalLanguageButton active={this.state.showInTranslatedLang} handleClick={this.toggleShowInTranslatedLang} eventSource="Reviews Feed" />
      );
    }
    let editDeleteSpan = null;
    if (this.props.review.user.id == this.props.currentUserId) {
      editDeleteSpan = (
        <span>
          <button onClick={wrapEventHandler(this.handleDeleteReviewClick)} className={`${styles.link} ${styles.action}`} rel="nofollow">
            {StringConstantsMixin.strings.DELETE}
          </button>
          <a href="#edit-review" onClick={this.openReviewFormModal} className={`${styles.link} ${styles.action}`} rel="nofollow">
            {StringConstantsMixin.strings.EDIT}
          </a>
        </span>
      );
    } else if (this.props.adminUser) {
      editDeleteSpan = (
        <span>
          <button onClick={wrapEventHandler(this.handleDeleteReviewClick)} className={`${styles.link} ${styles.action}`} rel="nofollow">
            {StringConstantsMixin.strings.DELETE}
          </button>
          <a onClick={this.handleAdminReplyClick} className={`${styles.link} ${styles.action}`} rel="nofollow">
            {StringConstantsMixin.strings.COMMENT}
          </a>
        </span>
      );
    }
    if (langButton || editDeleteSpan) {
      return (
        <div className={styles.actions}>
          {langButton}
          {editDeleteSpan}
        </div>
      );
    }
    return null;
  };

  getTagNames = () => {
    let tags = [];
    if (this.props.review.activity) {
      tags.push(StringConstantsMixin.stringsLookup(StringConstantsMixin.strings.FILTERS.ACTIVITIES, this.props.review.activity.name));
    }
    if (this.props.review.obstacles) {
      const sortedObs = this.props.review.obstacles
        .map(obstacle => {
          return StringConstantsMixin.stringsLookup(StringConstantsMixin.strings.FILTERS.OBSTACLES, obstacle.name);
        })
        .sort();
      tags = tags.concat(sortedObs);
    }
    return tags;
  };

  handleDeleteReviewClick = e => {
    if (!confirm('Are you sure you want to delete this review?')) return false;
    const url = `/my/reviews/${this.props.review.id}`;
    ServerCommunicationUtil.deleteApiEndpoint(url, {}, this.handleReviewDeleted, this.handleReviewDeletedError, this.handleReviewDeletedComplete);
    return false;
  };

  handleAdminReplyClick = e => {
    this.setState({ showReplyEditing: true });
  };

  handleReplyEditCancel = e => {
    this.setState({ showReplyEditing: false });
  };

  handleDeleteReplyClick = e => {
    const { id, trailId, replies } = this.props.review;
    if (replies) {
      ServerCommunicationUtil.deleteApiEndpoint(
        `/api/alltrails/trails/${trailId}/reviews/${id}/replies/${replies[0].id}`,
        {},
        this.changeRepliesSuccessCallback,
        () => {},
        () => {}
      );
    }
  };

  handleReplySave = textComment => {
    const { id, trailId, replies } = this.props.review;
    if (replies && replies.length > 0) {
      ServerCommunicationUtil.putApiEndpoint(
        `/api/alltrails/trails/${trailId}/reviews/${id}/replies/${replies[0].id}`,
        { comment: textComment },
        this.changeRepliesSuccessCallback,
        err => {
          console.error(err);
        },
        () => {}
      );
    } else {
      ServerCommunicationUtil.postApiEndpoint(
        `/api/alltrails/trails/${trailId}/reviews/${id}/replies`,
        { comment: textComment },
        this.changeRepliesSuccessCallback,
        err => {
          console.error(err);
        },
        () => {}
      );
    }
  };

  handleReviewDeleted = (xhr, status) => {
    if (this.props.onReviewDeleted && xhr.trails && xhr.trails.length > 0) {
      this.props.onReviewDeleted(this.props.review, xhr.trails[0]);
    }
  };

  handleReviewDeletedComplete = (xhr, status) => {};

  handleReviewDeletedError = (xhr, status, error) => {
    console.log(`Failure: ${error}`);
  };

  changeRepliesSuccessCallback = xhr => {
    if (this.props.updateReview && xhr.trail_reviews && xhr.trail_reviews.length > 0) {
      this.setState({ showReplyEditing: false });
      this.props.updateReview({ detail: xhr.trail_reviews[0] });
    }
  };

  renderAdminRepliesSection = () => {
    if (this.state.showReplyEditing || this.props.review.replies) {
      // right now we only support 1 response, but this can be reworked to add more
      let existingReply;
      if (this.props.review.replies) {
        existingReply = this.props.review.replies[0];
      }
      return (
        <AdminReplyItem
          reply={existingReply}
          handleReplySave={this.handleReplySave}
          handleReplyEditCancel={this.handleReplyEditCancel}
          handleDeleteReplyClick={this.handleDeleteReplyClick}
          showReplyEditing={this.state.showReplyEditing}
          locale={this.props.context.languageRegionCode}
          adminUser={this.props.adminUser}
        />
      );
    }

    return null;
  };

  toggleShowInTranslatedLang = () => {
    this.setState({ showInTranslatedLang: !this.state.showInTranslatedLang });
  };

  nameLinkSettings() {
    const {
      includeTrailName,
      review: { trailName, trailSlug }
    } = this.props;
    if (!includeTrailName || !trailName || !trailSlug) {
      return null;
    }

    return {
      link: `/trail/${trailSlug}`,
      name: trailName,
      verb: StringConstantsMixin.strings.REVIEWED
    };
  }

  render() {
    let comment = null;
    let detailsDiv = null;
    if (!this.state.showInTranslatedLang && this.props.review.comment_source && this.props.review.comment_source != '') {
      comment = this.props.review.comment_source;
    } else if (this.props.review.comment && this.props.review.comment != '') {
      comment = this.props.review.comment;
    }
    if (comment) {
      const classes = [styles.details, StringConstantsMixin.constants.XLATE.GOOGLE];
      let firstReviewDiv = null;
      if (this.props.review.badges && this.props.review.badges.first) {
        classes.push(styles.firstToReview);
        firstReviewDiv = (
          <div className={styles.badgeHolder}>
            <img src={FirstToReviewBadge} />
            {StringConstantsMixin.strings.FIRST_TO_REVIEW}
          </div>
        );
      }
      detailsDiv = (
        <div className={classes.join(' ')}>
          {firstReviewDiv}
          <p itemProp="reviewBody">{comment}</p>
        </div>
      );
    }
    return (
      <div itemScope itemProp="review" itemType="http://schema.org/Review" className={styles.container}>
        <div>
          <TrailUgcCardContent
            className={styles.content}
            context={this.props.context}
            created_at={this.props.review.metadata.created}
            item={this.props.review}
            tagNames={this.getTagNames()}
            nameLinkSettings={this.nameLinkSettings()}
          />
          {detailsDiv}
        </div>
        {this.renderAdminRepliesSection()}
        {this.recordingLink()}
        {this.actionsDiv()}
      </div>
    );
  }
}

TrailReviewResultCard.propTypes = {
  adminUser: PropTypes.bool,
  context: PropTypes.object,
  currentUserId: PropTypes.number,
  onReviewDeleted: PropTypes.func,
  updateReview: PropTypes.func,
  review: PropTypes.object.isRequired,
  userId: PropTypes.number
};

export default TrailReviewResultCard;
